import type { TOC } from '@ember/component/template-only'
import { camelize } from '@ember/string'
import RouteTemplate from 'ember-route-template'
import { BooksReadByLevelHistory } from 'teacher-ui-client/components/giraffe/charts/books-read/by-level/history'
import { BooksReadByLevelTotals } from 'teacher-ui-client/components/giraffe/charts/books-read/by-level/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { t } from 'ember-intl'
import type { BooksReadByLevelRexRoute } from 'teacher-ui-client/reporting/ui-scope/rex/books-read/by-level/route'
import { not } from 'ember-truth-helpers'
import { array } from '@ember/helper'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<BooksReadByLevelRexRoute>
}

export const RexBooksReadByLevel: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.booksReadByLevel"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.booksReadByLevelTotals true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.booksReadByLevelTotals}}>
    {{#if @model.booksReadByLevelTotals}}
      {{#each @model.booksReadByLevelTotals as |gradeData|}}
        <div
          class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
        >
          <BooksReadByLevelTotals
            @data={{gradeData}}
            @grade={{fullGradeName gradeData.grade_position}}
            @summaryTitle={{t
              (concat "reporting.summaryTitles.booksReadByLevelTotals." (camelize @model.uiScope.scope))
            }}
            @title={{t "reporting.chartTitles.booksReadByLevelTotals"}}
            @tooltip={{t "reporting.tooltips.booksReadByLevelTotals"}}
          />
        </div>
      {{/each}}
    {{/if}}

    {{#if @model.booksReadByLevelHistory}}
      <div class="my-10">
        <BooksReadByLevelHistory
          @booksReadByLevelData={{@model.booksReadByLevelHistory}}
          @students={{@model.scopedStudents}}
          @subco={{(isSubco)}}
          @uiScope={{@model.uiScope.scope}}
          @studentRouteName="reporting.ui-scope.rex.student-summary"
          @tooltip={{t "reporting.tooltips.booksReadByLevelHistory"}}
        />
      </div>
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(RexBooksReadByLevel)
